export default __webpack_public_path__ + "static/error-4156c5d71aeb4e1f68e594c463897f25.webp";